import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import { AnimatedChip, Chip, SVGIcon } from '@pearsontechnology/aero-components';

import { status as publishStatus } from '../../utils/constants';

const publicationStatus = {
  INPROGRESS: 'grey',
  COMPLETED: 'green',
  FAILED: 'orange',
};

const chipStyle = css`
  height: 26px;
  white-space: nowrap;
  justify-content: center;
  width:100%;
`;

export const Content = styled.div`
  padding: 20px;

  & > ul {
    margin: 0;
  }

  & > ul > li {
    line-height: 25px;
  }
`;

export const Section = styled.div`
  display: inline-block;
  margin: 10px 0 10px 0;
`;

export const Status = styled.div`
  width: 120px;
  display: flex;
  cursor: pointer;
`;

const StyledChip = styled(Chip)`
  ${chipStyle};
`;

const StyledAnimatedChip = styled(AnimatedChip)`
  line-height: 26px;
  ${chipStyle};
`;

export const Icon = styled(SVGIcon)`
  cursor: pointer;
  width:30px;
`;

export const StatusChip = ({ status, children }) => {
  const chipColor = publicationStatus[status];
  return status !== publishStatus.INPROGRESS &&
    status !== publishStatus.PUBLISH_STARTED ?
    (<StyledChip small {...{ [chipColor]: true }}>{children}</StyledChip >) :
    (<StyledAnimatedChip animationTime="5s">{children}</StyledAnimatedChip>);
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  children: PropTypes.string,
};